<template>
<div>
    <!-- <div v-if="menu == 0">
                    <pre>{{ sendPuntos }}</pre>
                    <div style="text-align: center;">
                        <vx-card title="Cobranzas">
                            <vs-row vs-justify="center">
                                <vs-col vs-w="12" class="vs-align-center m-2">
                                    <h2 class="text-danger">Sin Documentos</h2>
                                    <center>
                                        <img width="100" style="margin-top: 25px;" src="https://cdn-icons-png.flaticon.com/512/5433/5433091.png" alt="">
                                    </center>
                                    <vs-alert color="danger" title="Sin Documentos" active="true">
                                        Dato Seleccionado sin documentos (preFacturas o Notas).
                                    </vs-alert>
                                </vs-col>
                            </vs-row>
                        </vx-card>
                    </div>
                </div> -->
    <div v-if="menu == 3">
        <div class="m-3">
            <div>
                <vx-card class="m-5" v-if="arregloContrarios.length>0" title-color="#EA5455" title="Se encontraron documentos con variación en el CI/RUC de este cliente.">
                    <div>
                        <vs-table max-items="10" :data="arregloContrarios " v-if="arregloContrarios.length>0" striped>
                            <template slot="header">
                                <vs-chip class="m-2" color="danger">Cantidad: <b> {{ arregloContrarios.length }}</b></vs-chip>
                            </template>
                            <template slot="thead">
                                <vs-th>Documento</vs-th>
                                <vs-th>Ruc / Cédula</vs-th>
                            </template>
                            <template slot-scope="{data}">
                                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" :state="arregloContrarios.length>0 ? 'danger':null">
                                    <vs-td>
                                        {{ tr.ven_codigo }}<br>
                                    </vs-td>
                                    <vs-td>
                                        {{ tr.ruc_cliente}}<br>
                                    </vs-td>
                                </vs-tr>
                            </template>
                        </vs-table>
                    </div>
                </vx-card>
                <div>
                    <h3>Cobranzas de: {{datosCliente[0].razonsocial}}</h3>

                    <!-- Resumen de totales -->
                    <div class="flex flex-wrap justify-center gap-4 p-4">
                        <!-- Primer total: PreFacturas y Notas -->
                        <div class="text-center m-4 w-full sm:w-1/2 md:w-1/2 lg:w-1/5">
                            <img width="70" src="https://cdn-icons-png.flaticon.com/512/9582/9582985.png" alt="" class="mx-auto">
                            <span class="text-purple block mt-2">Total PreFact. y Notas</span>
                            <h2 class="font-bold text-purple mt-1">${{ (totalFacturas + totalNotas) | filtrarDecimal }}</h2>
                        </div>

                        <!-- Segundo total: Abonos -->
                        <div class="text-center m-4 w-full sm:w-1/2 md:w-1/2 lg:w-1/5">
                            <img width="70" src="https://cdn-icons-png.flaticon.com/512/9582/9582990.png" alt="" class="mx-auto">
                            <span class="text-orange block mt-2">Total Abonos</span>
                            <h2 class="font-bold text-orange mt-1">${{ (abonoFacturas + abonoNotas) | filtrarDecimal }}</h2>
                        </div>

                        <!-- Tercero total: devoluciones -->
                        <div class="text-center m-4 w-full sm:w-1/2 md:w-1/2 lg:w-1/5" v-if="devoluciones_all.length > 0">
                            <img width="70" src="https://cdn-icons-png.flaticon.com/512/9582/9582998.png" alt="" class="mx-auto">
                            <span class="text-blue block mt-2">Total Devoluciones</span>
                            <h2 class="font-bold text-blue mt-1">${{ (totalDevolucionesFacturas + totalDevolucionesNotas) | filtrarDecimal }}</h2>
                        </div>

                        <!-- Cuarto total: devoluciones sin empresa -->
                        <div class="text-center m-4 w-full sm:w-1/2 md:w-1/2 lg:w-1/5" v-if="datosDevolucionesSinEmpresa.length > 0">
                            <img width="70" src="https://cdn-icons-png.flaticon.com/512/5427/5427430.png" alt="" class="mx-auto">
                            <span class="text-red block mt-2">Total Dev. Sin Empresa</span>
                            <h2 class="font-bold text-red mt-1">${{ totalDevolucionesSinEmpresa | filtrarDecimal }}</h2>
                        </div>
                    </div>

                    <div class="flex justify-center my-3">
                        <vs-button v-if="datosDevolucionesSinEmpresa.length>0" color="danger" type="line" @click="popupVerSinEmpresa = true" icon-pack="feather" icon="icon-eye">
                            Devoluciones sin empresa
                        </vs-button>
                    </div>

                    <div class="flex justify-between">
                        <!-- Botones Generar -->
                        <div class="justify-start m-4 z-10">
                            <vs-button style="margin: 3px 5px 3px 5px" color="#28C76F" type="relief" @click="newAbono()" v-if="AdminFacturador">Nuevo Abono</vs-button>
                            <vs-button style="margin: 3px 5px 3px 5px" color="#c72850" type="relief" @click="verificareditornew = 'new';NuevaRetencion()" v-if="cantidadFacturas > 0">Generar Retención</vs-button>
                            <vs-button style="margin: 3px 5px 3px 5px" color="#c76d28" type="relief" @click="NuevoCruce()" v-if="cantidadFacturas > 0 || cantidadNotas > 0">Nuevo Cruce</vs-button>
                        </div>

                        <!-- Boton reporte -->
                        <div class="justify-end m-4 z-10">
                            <vs-button style="margin: 3px 5px 3px 5px" v-if="cargoDevoluciones==true" color="primary" type="relief" @click="popupPDF = true">Reporte Individual</vs-button>
                        </div>
                    </div>

                    <!-- Botón para nueva retención -->
                    <!-- <div class="m-2" v-if="userRoot">
                        <div class="flex justify-start">
                            <vs-button color="#28C76F" type="relief" @click="newAbono()" v-if="AdminFacturador">Nuevo Abono</vs-button>
                            <vs-button class="mx-5" color="#c72850" type="relief" @click="verificareditornew = 'new';NuevaRetencion()" v-if="cantidadFacturas > 0">Generar Retención</vs-button>
                        </div>
                    </div> -->

                    <!-- Tablas de PreFacturas y Notas -->
                    <div class="m-2">
                        <div class="flex flex-wrap w-full">
                            <!-- Primer bloque: PreFacturas -->
                            <div class="m-2 w-full lg:w-1/2 sm:w-full">
                                <div class="purple w-full">
                                    <div class="w-full">
                                        <p class="text-purple" style="font-size:20px;font-weight: 900;line-height: 1.3;">PreFacturas</p>
                                        <br>
                                        <table class="w-full custom-table-prefacturas">
                                            <tr>
                                                <td class="px-4 py-1">
                                                    <p style="font-size:15px;font-weight: 900;line-height: 1.3; color:black;">N° PreFacturas:</p>
                                                </td>
                                                <td class="text-right px-4 py-1">
                                                    <p style="font-size:15px;font-weight: 900;line-height: 1.3; color:black;"><b>{{ cantidadFacturas }}</b></p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="px-4 py-1">
                                                    <p style="font-size:15px;font-weight: 900;line-height: 1.3; color:black;">Total Ventas:</p>
                                                </td>
                                                <td class="text-right px-4 py-1">
                                                    <p style="font-size:15px;font-weight: 900;line-height: 1.3; color:black;"><b>${{ totalFacturas | filtrarDecimal }}</b></p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="px-4 py-1">
                                                    <p style="font-size:15px;font-weight: 900;line-height: 1.3; color:black;">N° Devoluciones Facturas:</p>
                                                </td>
                                                <td class="text-right px-4 py-1">
                                                    <p style="font-size:15px;font-weight: 900;line-height: 1.3; color:black;"><b>{{ devolucionesFacturas.length }}</b></p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="px-4 py-1">
                                                    <p style="font-size:15px;font-weight: 900;line-height: 1.3; color:black;">Total Devoluciones Facturas:</p>
                                                </td>
                                                <td class="text-right px-4 py-1">
                                                    <p style="font-size:15px;font-weight: 900;line-height: 1.3; color:black;"><b>${{ totalDevolucionesFacturas | filtrarDecimal }}</b></p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="px-4 py-1">
                                                    <p style="font-size:15px;font-weight: 900;line-height: 1.3; color:black;">Abonado en PreFacturas:</p>
                                                </td>
                                                <td class="text-right px-4 py-1">
                                                    <p style="font-size:15px;font-weight: 900;line-height: 1.3; color:black;"><b>${{ abonoFacturas | filtrarDecimal }}</b></p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="px-4 py-1">
                                                    <p style="font-size:15px;font-weight: 900;line-height: 1.3; color:black;">Cant. Retenciones:</p>
                                                </td>
                                                <td class="text-right px-4 py-1">
                                                    <p style="font-size:15px;font-weight: 900;line-height: 1.3; color:black;"><b>{{ totalRetencionValor }}</b></p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="px-4 py-1">
                                                    <p style="font-size:15px;font-weight: 900;line-height: 1.3; color:black;">Total Retenciones:</p>
                                                </td>
                                                <td class="text-right px-4 py-1">
                                                    <p style="font-size:15px;font-weight: 900;line-height: 1.3; color:black;"><b>${{ retencionValor | filtrarDecimal }}</b></p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="px-4 py-1">
                                                    <p style="font-size:15px;font-weight: 900;line-height: 1.3; color:black;">Cant. Cruces:</p>
                                                </td>
                                                <td class="text-right px-4 py-1">
                                                    <p style="font-size:15px;font-weight: 900;line-height: 1.3; color:black;"><b>{{ totalCruceValor }}</b></p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="px-4 py-1">
                                                    <p style="font-size:15px;font-weight: 900;line-height: 1.3; color:black;">Total Cruces:</p>
                                                </td>
                                                <td class="text-right px-4 py-1">
                                                    <p style="font-size:15px;font-weight: 900;line-height: 1.3; color:black;"><b>${{ cruceValor | filtrarDecimal }}</b></p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="px-4 py-1">
                                                    <p style="font-size:15px;font-weight: 900;line-height: 1.3; color:black;">Total Pagos:</p>
                                                </td>
                                                <td class="text-right px-4 py-1">
                                                    <p style="font-size:15px;font-weight: 900;line-height: 1.3; color:black;"><b>${{ totalDevolucionesFacturas + abonoFacturas + retencionValor + cruceValor | filtrarDecimal }}</b></p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="px-4 py-1">
                                                    <p style="font-size:15px;font-weight: 900;line-height: 1.3; color:black;">Saldo pendiente:</p>
                                                </td>
                                                <td class="text-right px-4 py-1">
                                                    <p style="font-size:15px;font-weight: 900;line-height: 1.3; color:black;"><b>${{ (totalFacturas - (totalDevolucionesFacturas + abonoFacturas + retencionValor + cruceValor)) | filtrarDecimal }}</b></p>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                    <div class="mt-4 text-center flex flex-wrap justify-center gap-4">
                                        <div v-if="cantidadFacturas > 0" class="mt-2 w-full sm:w-auto">
                                            <vs-button type="line" color="purple" @click="popupVerFacturas=true">Ver PreFacturas ({{ cantidadFacturas }})</vs-button>
                                        </div>
                                        <div v-if="devolucionesFacturas.length > 0" class="mt-2 w-full sm:w-auto">
                                            <vs-button type="line" color="purple" @click="popupVerFacturasDevoluciones=true">Ver Devoluciones ({{ devolucionesFacturas.length }})</vs-button>
                                        </div>
                                        <div class="mt-2 w-full sm:w-auto" v-if="totalRetencionValor>0">
                                            <vs-button type="line" color="hsl(261, 81%, 61%)" @click="ListadoRetenciones()">Ver Listado de Retenciones ({{ totalRetencionValor }})</vs-button>
                                        </div>
                                        <div v-if="totalCruceValor>0" class="mt-2 w-full sm:w-auto">
                                            <vs-button type="line" color="hsl(261, 81%, 61%)" @click="ListadoCruces('facturas')">Ver Listado de Cruces ({{ totalCruceValor }})</vs-button>
                                        </div>
                                    </div>
                                    <div class="mt-4 text-center">
                                        <p style="font-size:17px;font-weight: 600;line-height: 1.3;color:black;">N° Abonos PreFacturas: <b class="text-purple">{{ totalAbonoFacturas }}</b></p>
                                        <div v-if="totalAbonoFacturas > 0" class="mt-2">
                                            <vs-button v-if="AdminFacturador" color="#800080" type="relief" @click="openabonoFacturas()">Ver Abonos PreFacturas</vs-button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Segundo bloque: Notas -->
                            <div class="m-2 w-full lg:w-2/5 sm:w-full">
                                <div class="orange w-full">
                                    <div class="w-full">
                                        <h2 class="text-orange" style="font-size:20px;font-weight: 900;line-height: 1.3;">Notas</h2>
                                        <br>
                                        <table class="w-full custom-table-notas">
                                            <tr>
                                                <td class="px-4 py-1">
                                                    <p style="font-size:15px;font-weight: 900;line-height: 1.3; color:black;">N° Notas:</p>
                                                </td>
                                                <td class="text-right px-4 py-1">
                                                    <p style="font-size:15px;font-weight: 900;line-height: 1.3; color:black;"><b>{{ cantidadNotas }}</b></p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="px-4 py-1">
                                                    <p style="font-size:15px;font-weight: 900;line-height: 1.3; color:black;">Total Ventas:</p>
                                                </td>
                                                <td class="text-right px-4 py-1">
                                                    <p style="font-size:15px;font-weight: 900;line-height: 1.3; color:black;"><b>${{ totalNotas.toFixed(2) }}</b></p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="px-4 py-1">
                                                    <p style="font-size:15px;font-weight: 900;line-height: 1.3; color:black;">N° Devoluciones Notas:</p>
                                                </td>
                                                <td class="text-right px-4 py-1">
                                                    <p style="font-size:15px;font-weight: 900;line-height: 1.3; color:black;"><b>{{ devolucionesNotas.length }}</b></p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="px-4 py-1">
                                                    <p style="font-size:15px;font-weight: 900;line-height: 1.3; color:black;">Total Devoluciones Notas:</p>
                                                </td>
                                                <td class="text-right px-4 py-1">
                                                    <p style="font-size:15px;font-weight: 900;line-height: 1.3; color:black;"><b>${{ totalDevolucionesNotas | filtrarDecimal }}</b></p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="px-4 py-1">
                                                    <p style="font-size:15px;font-weight: 900;line-height: 1.3; color:black;">Abonado en Notas:</p>
                                                </td>
                                                <td class="text-right px-4 py-1">
                                                    <p style="font-size:15px;font-weight: 900;line-height: 1.3; color:black;"><b>${{ abonoNotas.toFixed(2) }}</b></p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="px-4 py-1">
                                                    <p style="font-size:15px;font-weight: 900;line-height: 1.3; color:black;">Cant. Cruces:</p>
                                                </td>
                                                <td class="text-right px-4 py-1">
                                                    <p style="font-size:15px;font-weight: 900;line-height: 1.3; color:black;"><b>{{ totalCruceValorNotas }}</b></p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="px-4 py-1">
                                                    <p style="font-size:15px;font-weight: 900;line-height: 1.3; color:black;">Total Cruces:</p>
                                                </td>
                                                <td class="text-right px-4 py-1">
                                                    <p style="font-size:15px;font-weight: 900;line-height: 1.3; color:black;"><b>${{ cruceValorNotas | filtrarDecimal }}</b></p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="px-4 py-1">
                                                    <p style="font-size:15px;font-weight: 900;line-height: 1.3; color:black;">Saldo pendiente:</p>
                                                </td>
                                                <td class="text-right px-4 py-1">
                                                    <p style="font-size:15px;font-weight: 900;line-height: 1.3; color:black;"><b>${{ (totalNotas - (totalDevolucionesNotas + abonoNotas + cruceValorNotas)).toFixed(2) }}</b></p>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                    <div class="mt-4 text-center flex flex-wrap justify-center gap-4">
                                        <div v-if="cantidadNotas > 0" class="mt-2 w-full sm:w-auto">
                                            <vs-button type="line" color="orange" @click="popupVerNotas=true">Ver Notas ({{ cantidadNotas }})</vs-button>
                                        </div>
                                        <div v-if="devolucionesNotas.length > 0" class="mt-2 w-full sm:w-auto">
                                            <vs-button type="line" color="orange" @click="popupVerNotasDevoluciones=true" :badge="devolucionesNotas.length">Ver Devoluciones ({{ devolucionesNotas.length }})</vs-button>
                                        </div>
                                        <div v-if="totalCruceValorNotas>0" class="mt-2 w-full sm:w-auto">
                                            <vs-button type="line" color="orange" @click="ListadoCruces('notas')">Ver Listado de Cruces ({{ totalCruceValorNotas }})</vs-button>
                                        </div>
                                    </div>
                                    <div class="mt-4 text-center">
                                        <p style="font-size:17px;font-weight: 600;line-height: 1.3;color:black;">N° Abonos Notas: <b class="text-orange">{{ totalAbonoNotas }}</b></p>
                                        <div v-if="totalAbonoNotas > 0" class="mt-2">
                                            <vs-button v-if="AdminFacturador" color="orange" type="relief" @click="openabonoNotas()">Ver Abonos Notas</vs-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
    <div v-if="mostrarCheques" class="m-3">
        <vs-divider>Sección Cheques</vs-divider>
        <div style="align-content: start;" v-if="AdminFacturador">
            <div>
                <div class="flex justify-start">
                    <div class="m-2">
                        <vs-button color="primary" type="relief" @click="newCheque()">Registro cheque</vs-button>
                    </div>
                </div>
            </div>
            <div class="m-2">
                <screenCheques :nombreCliente="nombreCliente" :datosCliente="datosCliente" :empresaCobranza="empresaCobranza" :Cheques="Cheques" :permisosCheque="permisosCheque" :periodoSelect="periodoSelect" :periodoPuntosOInstitucion="periodoPuntosOInstitucion" @chequeCobrado="chequeCobrado" :totalFacturas="totalFacturas" :totalNotas="totalNotas" />
            </div>
        </div>
    </div>
    <div>
        <!-- <div v-if="menu == 1"> -->
        <!-- <vs-button line-position="top" line-origin="right" color="primary" type="line" @click="menu = 3; mostrarCheques = true;">🡨 Regresar</vs-button> -->
        <vs-popup fullscreen v-if="popupVerFacturas" title="Facturas" :active.sync="popupVerFacturas" class="popopPadre">
            <screenFacturas v-if="popupVerFacturas" :arreglofacturas="arreglofacturas" :institucionPuntosOInstitucion="institucionPuntosOInstitucion" :periodoPuntosOInstitucion="periodoPuntosOInstitucion" />
        </vs-popup>
        <vs-popup fullscreen v-if="popupVerFacturasDevoluciones" title="Devoluciones de Facturas" :active.sync="popupVerFacturasDevoluciones" class="popopPadre">
            <!-- {{devolucionesFacturas}} -->
            <screenFacturasDevolucion v-if="popupVerFacturasDevoluciones" :devolucionesFacturas="devolucionesFacturas" :institucionPuntosOInstitucion="institucionPuntosOInstitucion" :periodoPuntosOInstitucion="periodoPuntosOInstitucion" />
        </vs-popup>
    </div>
    <div>
        <!-- <div v-if="menu == 2"> -->
        <!-- <vs-button line-position="top" line-origin="right" color="primary" type="line" @click="menu = 3; mostrarCheques = true;">🡨 Regresar</vs-button> -->
        <vs-popup fullscreen v-if="popupVerNotas" title="Notas" :active.sync="popupVerNotas" class="popopPadre">
            <screenNotas v-if="popupVerNotas" :arreglonotas="arreglonotas" />
        </vs-popup>
        <vs-popup fullscreen v-if="popupVerNotasDevoluciones" title="Devoluciones de Notas" :active.sync="popupVerNotasDevoluciones" class="popopPadre">
            <screenNotasDevolucion v-if="popupVerNotasDevoluciones" :devolucionesNotas="devolucionesNotas" />
        </vs-popup>
    </div>
    <div>
        <vs-popup fullscreen :title="`Devoluciones sin empresa`" :active.sync="popupVerSinEmpresa" class="popopPadre">
            <div>
                <div>
                    <h4 style="color: red;">ESTOS <b>VALORES DE DOCUMENTOS DE DEVOLUCIÓN</b> NO HAN SIDO APLICADOS A NINGUNA EMPRESA Y NO TIENEN DESCUENTOS APLICADOS.</h4>
                </div>
                <!-- Mostrar tabla de devoluciones sin empresa -->
                <div v-if="datosDevolucionesSinEmpresa.length > 0">
                    <vs-table max-items="10" pagination search :data="datosDevolucionesSinEmpresa">
                        <template slot="thead">
                            <vs-th>Codigo Devolución</vs-th>
                            <vs-th>Institución</vs-th>
                            <vs-th>Total Precio</vs-th>
                        </template>
                        <template slot-scope="{data}">
                            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                                <vs-td>{{ tr.codigo_devolucion }}</vs-td>
                                <vs-td>{{ tr.nombreInstitucion }}</vs-td>
                                <vs-td>{{ tr.total_precio.toFixed(2) }}</vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>

                    <!-- Mostrar el total de devoluciones -->
                    <div class="total">
                        <strong>Total Devoluciones Sin Empresa:</strong>
                        <h4 class="mx-3">{{ totalDevolucionesSinEmpresa.toFixed(2) }}</h4>
                    </div>
                </div>

                <!-- Mostrar mensaje si no hay datos -->
                <div v-else>
                    <p>No hay devoluciones sin empresa.</p>
                </div>
            </div>
        </vs-popup>
    </div>
    <vs-popup v-if="popupAbonos" title="Abono" :active.sync="popupAbonos" @close="handleCloseAbono" :class="{ 'hide-close': !showCloseButton }">
        <vs-row>
            <vs-col vs-justify="center" vs-align="center" vs-lg="6" vs-sm="12" vs-xs="12">
                <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                    <vs-col vs-justify="center" vs-align="center" vs-w="10">
                        <div>Fecha: </div>
                        <!-- <vs-input type="date" class="inputx w-full mb-6" v-model="tabAbono.fecha" placeholder="fecha"/> -->
                        <flat-pickr :config="configdateTimePicker" v-model="tabAbono.fecha" placeholder="Fecha " style="display: inline-block;width: 100%" />
                    </vs-col>
                </vs-row>
            </vs-col>
            <vs-col vs-justify="center" vs-align="center" vs-lg="6" vs-sm="12" vs-xs="12">
                <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                    <vs-col vs-justify="center" vs-align="center" vs-w="10">
                        <font style="font-size: 11.5px">Cuenta:</font><br>
                        <v-select :options="Cuentas" :reduce="Cuentas => Cuentas.cue_pag_codigo" label="cue_pag_nombre" class="w-full h-100" placeholder="--Seleccione--" v-model="tabAbono.cuenta" />
                    </vs-col>
                </vs-row>
            </vs-col>
        </vs-row>
        <vs-row class="mt-2">
            <vs-col vs-justify="center" vs-align="center" vs-lg="6" vs-sm="12" vs-xs="12">
                <vs-row vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
                    <div class="text-danger" v-if="tabAbono.cuenta == 6"><b>Ingreso de liquidación</b></div>
                </vs-row>
            </vs-col>
        </vs-row>
        <vs-row class="mt-2">
            <vs-col vs-justify="center" vs-align="center" vs-lg="6" vs-sm="12" vs-xs="12">
                <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                    <vs-col vs-justify="center" vs-align="center" vs-w="10">
                        <div class="mb-2">Tipo:</div>
                        <vs-radio v-model="tabAbono.tipoAbono" class="ml-2" vs-name="radiostipoAbono" vs-value="0">Deposito</vs-radio>
                        <vs-radio v-model="tabAbono.tipoAbono" class="ml-2" vs-name="radiostipoAbono" vs-value="1">Transferencia</vs-radio>
                        <!-- <vs-radio v-model="tabAbono.tipoAbono" class="ml-2" vs-name="radiostipoAbono" vs-value="2" >cheque</vs-radio> -->
                    </vs-col>
                </vs-row>
            </vs-col>
            <vs-col vs-justify="center" vs-align="center" vs-lg="6" vs-sm="12" vs-xs="12">
                <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                    <vs-col vs-justify="center" vs-align="center" vs-w="10">
                        <div class="mb-2">Documento Abono #:</div>
                        <vs-input type="number" class="inputx w-full mb-6" v-model="tabAbono.numeroDocumento" placeholder="Numero deposito" @blur="agregarValorAlTextarea" />
                    </vs-col>
                </vs-row>
            </vs-col>
        </vs-row>
        <vs-row class="mt-2">
            <vs-col vs-justify="center" vs-align="center" vs-lg="6" vs-sm="12" vs-xs="12">
                <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                    <vs-col vs-justify="center" vs-align="center" vs-w="10">
                        <div class="mb-2">Destino:</div>
                        <!-- <vs-radio v-model="tabAbono.notasOfactura" class="ml-2" vs-name="radiosNotas" vs-value="1" :disabled="totalNotas == 0" @change="resetearValor">Notas</vs-radio>
                                    <vs-radio v-model="tabAbono.notasOfactura" class="ml-2" vs-name="radiosNotas" vs-value="0" :disabled="totalFacturas == 0" @change="resetearValor">Facturas</vs-radio> -->
                        <vs-radio v-model="tabAbono.notasOfactura" class="ml-2" vs-name="radiosNotas" vs-value="1">Notas</vs-radio>
                        <vs-radio v-model="tabAbono.notasOfactura" class="ml-2" vs-name="radiosNotas" vs-value="0">Facturas</vs-radio>
                    </vs-col>
                </vs-row>
            </vs-col>
            <vs-col vs-justify="center" vs-align="center" vs-lg="6" vs-sm="12" vs-xs="12">
                <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                    <vs-col vs-justify="center" vs-align="center" vs-w="10">
                        <div>Valor Abono:</div>
                        <!-- <vs-input type="text" class="inputx w-full mb-6" v-model="tabAbono.valor" placeholder="Valor" :disabled="!tabAbono.notasOfactura" @click.native="seleccionTipo" @keypress="validateInput" @paste="validatePaste" min="0" :max="tabAbono.notasOfactura == 0 ? (totalNotas - abonoNotas): (totalFacturas - abonoFacturas)" @input="validateQuantity()" /> -->
                        <vs-input type="text" class="inputx w-full mb-6" v-model="tabAbono.valor" placeholder="Valor" :disabled="!tabAbono.notasOfactura" @paste="validatePaste" min="0" @click.native="seleccionTipo" />
                    </vs-col>
                </vs-row>
            </vs-col>
        </vs-row>
        <vs-row class="mt-2">
            <vs-col vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12">
                <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                    <vs-col vs-justify="center" vs-align="center" vs-w="10">
                        <div>Concepto del Abono:</div>
                        <!-- <vs-input type="text" class="inputx w-full mb-6" v-model="tabAbono.valor" placeholder="Valor" :disabled="!tabAbono.notasOfactura" @click.native="seleccionTipo" @keypress="validateInput" @paste="validatePaste" min="0" :max="tabAbono.notasOfactura == 0 ? (totalNotas - abonoNotas): (totalFacturas - abonoFacturas)" @input="validateQuantity()" /> -->
                        <div @mousedown="seleccionTipo2">
                            <vs-textarea class="inputx w-full mb-6" v-model="tabAbono.concepto" placeholder="concepto" :readonly="!tabAbono.numeroDocumento" />
                        </div>
                    </vs-col>
                </vs-row>
            </vs-col>
        </vs-row>
        <br><br>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12" class="mt-2">
            <vs-button @click="guardarAbono()" type="relief">Guardar</vs-button>&emsp;
            <vs-button @click="popupAbonos=false" color="danger" type="relief">Cancelar</vs-button>
        </vs-col>
    </vs-popup>
    <vs-popup fullscreen v-if="popupAbonosNotas" title="Notas abonos" :active.sync="popupAbonosNotas" class="popopPadre">
        <notasAbono :periodo="periodoPuntosOInstitucion" :empresa="empresa.id" :cliente="Number(datosCliente[0].identificacion)" @actualizarTodo="actualizarTodo" />

        <!-- <vs-table max-items="10" pagination :data="arregloAbonoNotas">
                        <template slot="thead">
                            <vs-th>Información</vs-th>
                            <vs-th>Acciones</vs-th>
                        </template>
                        <template slot-scope="{data}">
                            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                                <vs-td>
                                    <b>Fecha Abono:</b> {{ tr.abono_fecha }} <br>
                                    <b>Valor Abono:</b> ${{ tr.abono_notas }} <br>
                                    <b>Tipo:</b> {{ tr.abono_tipo == 0 ? 'Deposito': tr.abono_tipo == 1 ? 'Transferencia': tr.abono_tipo == 2 ? 'Cheque': ' Retencion' }} <br>
                                    <b>Documento:</b> {{ tr.abono_documento }} <br>
                                </vs-td>
                                <vs-td align="center">
                                  <vx-tooltip v-if="usuario.id_group==1"text="Editar" position="top" color="danger">
                                        <vs-button  v-if="tr.estadoPerseo == 0" @click="remover(tr);" color="danger" type="relief" icon="delete"></vs-button>
                                  </vx-tooltip>                   
                              </vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                    <br><br>
                    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12" class="mt-2">
                        <vs-button @click="popupAbonosNotas=false" color="danger" type="relief">Volver</vs-button>
                    </vs-col> -->
    </vs-popup>
    <vs-popup fullscreen v-if="popupAbonosFacturas" title="Facturas abonos" :active.sync="popupAbonosFacturas" class="popopPadre">
        <!-- <facturasAbono :arregloAbonoFacturas="arregloAbonoFacturas" :periodo="periodoPuntosOInstitucion" :empresa="empresa.id" :cliente="datosCliente[0].identificacion"/> -->
        <facturasAbono :periodo="periodoPuntosOInstitucion" :empresa="empresa.id" :cliente="Number(datosCliente[0].identificacion)" @actualizarTodo="actualizarTodo" />
        <!-- <pre>{{ arregloAbonoFacturas }}</pre> -->
        <!-- <vs-table max-items="10" pagination :data="arregloAbonoFacturas">
                        <template slot="thead">
                            <vs-th>Información Abono</vs-th>
                            <vs-th>Acciones</vs-th>
                        </template>
                        <template slot-scope="{data}">
                            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                                <vs-td>
                                    <b>Fecha Abono:</b> {{ tr.abono_fecha }} <br>
                                    <b>Valor Abono:</b> ${{ tr.abono_facturas }} <br>
                                    <b>Tipo:</b> {{ tr.abono_tipo == 0 ? 'Deposito': tr.abono_tipo == 1 ? 'Transferencia': tr.abono_tipo == 2 ? 'Cheque': ' Retencion' }} <br>
                                    <b>Documento:</b> {{ tr.abono_documento }} <br>
                                    <b>Concepto:</b> {{ tr.abono_concepto  }} <br>
                                    <b>Estado envio Perseo:</b>
                                    <div v-if="tr.estadoPerseo == 0">
                                        <vs-chip color="warning">No enviado a perseo</vs-chip>
                                    </div>
                                    <div v-else>
                                        <vs-chip color="success">Enviado a perseo</vs-chip>
                                    </div>
                                </vs-td>
                                <vs-td align="center">
                                  <vx-tooltip v-if="usuario.id_group==1" ext="Eliminar" position="top" style="z-index: 9999;">
                                        <vs-button  v-if="tr.estadoPerseo == 0" @click="remover(tr);" color="danger" type="relief" icon="delete"></vs-button>
                                  </vx-tooltip>
                                  <vs-button v-if="tr.estadoPerseo == 0" @click="tipoAbono=0;popupAbonosFacturas=false;ObjectSelected=tr;openConfirmEnviarPerseo(tr,1);" class="mt-3" color="primary" type="relief" icon="check">Enviar a perseo</vs-button>
                                  <br>                          
                              </vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                    <br><br>
                    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12" class="mt-2">
                        <vs-button @click="popupAbonosFacturas=false" color="danger" type="relief">Volver</vs-button>
                    </vs-col> -->
    </vs-popup>
    <vs-popup v-if="promptVisible" title="Abonos Eliminacion" :active.sync="promptVisible">
        <vs-row>
            <vs-col vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12" style="text-align: center;"><b style="font-size: 15px">Confirmar Eliminacion De Abono</b></vs-col>
            <vs-col vs-justify="center" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="6">
                <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                    ¿Estás seguro que deseas eliminar el abono con ID {{ abono_id.abono_id }}?
                </vs-row>
                <br><br>
                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12" class="mt-2">
                    <vs-button @click="eliminarAbono(abono_id)" color="danger" type="relief">Aceptar</vs-button>
                    <vs-button @click="cancelarEliminarAbono()" color="success" type="relief">Cancelar</vs-button>
                </vs-col>
            </vs-col>
        </vs-row>
    </vs-popup>
    <vs-popup v-if="popupCheques" :title="`Registro Cheque de ${ tabCheque.institucion }`" :active.sync="popupCheques" @close="handleCloseCheque" :class="{ 'hide-close': !showCloseButton }">
        <vs-row>
            <vs-col vs-justify="center" vs-align="center" vs-lg="6" vs-sm="12" vs-xs="12">
                <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                    <vs-col vs-justify="center" vs-align="center" vs-w="10">
                        <font style="font-size: 11.5px">Banco:</font><br>
                        <!-- <v-select :options="Bancos" :reduce="Bancos => Bancos.ban_codigo" label="ban_nombre" class="w-full h-100" placeholder="--Seleccione--" v-model="tabCheque.banco" /> -->
                        <v-select :options="Bancos" :reduce="Bancos => Bancos" label="descripcion" class="w-full h-100" placeholder="--Seleccione--" v-model="tabCheque.banco" />
                    </vs-col>
                </vs-row>
            </vs-col>
            <vs-col vs-justify="center" vs-align="center" vs-lg="6" vs-sm="12" vs-xs="12">
                <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                    <vs-col vs-justify="center" vs-align="center" vs-w="10">
                        <font style="font-size: 11.5px">Tipo de cheque:</font><br>
                        <v-select :options="tipoCheque" :reduce="(tipoCheque) => tipoCheque.value" label="text" value="value" class="w-full h-100" placeholder="--Seleccione--" v-model="tabCheque.tipoCheque" />
                    </vs-col>
                </vs-row>
            </vs-col>
        </vs-row>
        <vs-row>
            <vs-col vs-justify="center" vs-align="center" vs-lg="6" vs-sm="12" vs-xs="12">
                <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                    <vs-col vs-justify="center" vs-align="center" vs-w="10">
                        <div>Valor:</div>
                        <vs-input type="text" class="inputx w-full mb-6" v-model="tabCheque.valor" placeholder="Valor" @keypress="validateInput" @paste="validatePaste" min="0" />
                    </vs-col>
                </vs-row>
            </vs-col>
            <vs-col v-if="tabCheque.tipoCheque === 1" vs-justify="center" vs-align="center" vs-lg="6" vs-sm="12" vs-xs="12">
                <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                    <vs-col vs-justify="center" vs-align="center" vs-w="10">
                        <div>Fecha de cobro:</div>
                        <flat-pickr :config="configdateTimePicker" v-model="tabCheque.fechaCobro" placeholder="Fecha de cobro" style="display: inline-block;width: 100%" />
                    </vs-col>
                </vs-row>
            </vs-col>
        </vs-row>
        <vs-row class="mt-2">
            <vs-col vs-justify="center" vs-align="center" vs-lg="6" vs-sm="12" vs-xs="12">
                <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                    <vs-col vs-justify="center" vs-align="center" vs-w="10">
                        <div class="mb-2">Cuenta N°:</div>
                        <vs-input type="number" class="inputx w-full mb-6" v-model="tabCheque.cuentaCheque" placeholder="Cuenta numero" />
                    </vs-col>
                </vs-row>
            </vs-col>
            <vs-col vs-justify="center" vs-align="center" vs-lg="6" vs-sm="12" vs-xs="12">
                <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                    <vs-col vs-justify="center" vs-align="center" vs-w="10">
                        <div class="mb-2">Numero de Cheque:</div>
                        <vs-input type="number" class="inputx w-full mb-6" v-model="tabCheque.numeroCheque" placeholder="Numero de cheque" />
                    </vs-col>
                </vs-row>
            </vs-col>
        </vs-row>
        <vs-row class="mt-2">
            <vs-col vs-justify="center" vs-align="center" vs-lg="6" vs-sm="12" vs-xs="12">
                <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                    <vs-col vs-justify="center" vs-align="center" vs-w="10">
                        <div>Referencia:</div>
                        <vs-input type="text" class="inputx w-full mb-6" v-model="tabCheque.referencia" placeholder="Numero Documento" />
                    </vs-col>
                </vs-row>
            </vs-col>
        </vs-row>
        <br><br>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12" class="mt-2">
            <vs-button @click="guardarCheque()" type="relief">Guardar</vs-button>&emsp;
            <vs-button @click="popupCheques=false" color="danger" type="relief">Cancelar</vs-button>
        </vs-col>
    </vs-popup>
    <vs-popup fullscreen v-if="popupPDF" title="Abonos reporte" :active.sync="popupPDF">
        <div align="center" class="mb-5">
            <vs-button @click="imprimirPDF" type="relief" color="danger">Imprimir PDF</vs-button>
            <vs-button @click="descargarExcel" type="relief" color="success" class="mx-5">Descargar Excel</vs-button>
        </div>
        <div class="mt-4">
            <reporte :datosCliente="datosCliente" :empresaCobranza="empresaCobranza" :periodoPuntosOInstitucion="periodoPuntosOInstitucion" :periodoSelect="periodoSelect" :devoluciones_all="devoluciones_all" ref="hijoComponente" />
        </div>
    </vs-popup>
    <vs-popup :title="`Generar Retención `" :active.sync="popupRetencion" v-if="userRoot">
        <vs-row>
            <vs-col vs-justify="center" vs-align="center" vs-lg="6" vs-sm="12" vs-xs="12">
                <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                    <vs-col vs-justify="center" vs-align="center" vs-w="10">
                        <div>Fecha Retención:</div>
                        <flat-pickr :config="configdateTimePicker" v-model="tabRetencion.fechaRetencion" placeholder="Fecha de cobro" style="display: inline-block;width: 100%" />
                    </vs-col>
                </vs-row>
            </vs-col>
            <vs-col vs-justify="center" vs-align="center" vs-lg="6" vs-sm="12" vs-xs="12">
                <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                    <vs-col vs-justify="center" vs-align="center" vs-w="10">
                        <font style="font-size: 11.5px">Retencion de Retención:</font><br>
                        <v-select :options="porcentajeRetencion" :reduce="(porcentajeRetencion) => porcentajeRetencion.value" label="text" value="value" class="w-full h-100" placeholder="--Seleccione--" v-model="tabRetencion.porcentajeRetencion" />
                    </vs-col>
                </vs-row>
            </vs-col>
        </vs-row>
        <vs-row>
            <vs-col vs-justify="center" vs-align="center" vs-lg="6" vs-sm="12" vs-xs="12">
                <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                    <vs-col vs-justify="center" vs-align="center" vs-w="10">
                        <div>N° de Documento:</div>
                        <vs-input type="text" class="inputx w-full mb-6" v-model="tabRetencion.documento" placeholder="Numero de documento" @keypress="validateInput" @paste="validatePaste" min="0" readonly />
                    </vs-col>
                </vs-row>
            </vs-col>
            <vs-col vs-justify="center" vs-align="center" vs-lg="6" vs-sm="12" vs-xs="12">
                <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                    <vs-col vs-justify="center" vs-align="center" vs-w="10">
                        <div class="mb-2">Valor Retención:</div>
                        <vs-input type="number" class="inputx w-full mb-6" v-model="tabRetencion.valor" placeholder="Valor Retencion" />
                    </vs-col>
                </vs-row>
            </vs-col>
        </vs-row>
        <br><br>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12" class="mt-2">
            <vs-button @click="guardarRetencion()" type="relief">Guardar</vs-button>&emsp;
            <vs-button @click="popupRetencion=false" color="danger" type="relief">Cancelar</vs-button>
        </vs-col>
        <!-- <pre>{{ arregloaFactura }}</pre> -->
    </vs-popup>
    <!-- SECCION NUEVA RETENCION -->
    <vs-popup fullscreen class="informacionformhijo" @close="MetodosInicio()" title="Nueva Retención" :active.sync="popupRetencionNew">
        <RetencionesComponent v-if="popupRetencionNew" :verificareditornew="verificareditornew" :datos="datosCliente[0]" :empresa="empresaCobranza" @change="changeHandleRetencionComponent" />
    </vs-popup>
    <!-- SECCION LISTADO RETENCIONES -->
    <vs-popup fullscreen class="informacionformhijo" @close="MetodosInicio()" title="Listado Retenciones" :active.sync="popupListadoRetencion">
        <ListadoRetencionesComponent v-if="popupListadoRetencion" :datos="datosCliente[0]" :empresa="empresaCobranza" @change="changeHandleListadoRetencionComponent" />
    </vs-popup>
    <!-- SECCION CUENTAS CRUZADAS -->
    <!-- CREAR CRUCE -->
    <vs-popup fullscreen class="informacionformhijo" @close="CerrarCrearcionCruce('cancelar-guardado')" title="Crear Cruce" :active.sync="popupCuentasCruzadas">
        <createdCuentasCruzadas v-if="popupCuentasCruzadas" :datos="datosCliente[0]" :empresa="empresaCobranza" :periodoSelect="periodoSelect" @CerrarCrearcionCruce="CerrarCrearcionCruce" />
    </vs-popup>
    <!-- SECCION LISTADO CRUCES -->
    <vs-popup fullscreen class="informacionformhijo" title="Listado Cruces" :active.sync="popupListadoCruces">
        <ListadoCrucesComponent v-if="popupListadoCruces" :datos="datosCliente[0]" :empresa="empresaCobranza" :periodoSelect="periodoSelect" :tipoListadoCruces="tipoListadoCruces" @editadoCruce="editadoCruce" />
    </vs-popup>
</div>
</template>

<script>
import screenFacturas from "./facturas/screenFacturas.vue";
import screenFacturasDevolucion from "./facturas/screenDevolucionesFactura.vue";
import screenNotasDevolucion from "./facturas/screenDevolucionesNota.vue";
import screenNotas from "./facturas/screenNotas.vue";
import screenCheques from "./facturas/screenCheques.vue";
import createdCuentasCruzadas from "./cruceCuentas/createdCuentasCruzadas.vue";
import ListadoCrucesComponent from "./cruceCuentas/listCuentasCruzadas.vue";
import reporte from "./components/reporteCobranza.vue";
import facturasAbono from "./components/facturasAbono.vue";
import notasAbono from "./components/notasAbono.vue";
import vSelect from "vue-select";
import flatPickr from 'vue-flatpickr-component';
import {
    mapState
} from "vuex";
import XLSX from 'xlsx';
import imprimirMixin from "@/mixins/Pedidosmix";
import {
    set
} from "core-js/core/dict";
const RetencionesComponent = () => import("@/views/pedidos2/pedidos/cobranzas/components/Retencioncomponent.vue");
const ListadoRetencionesComponent = () => import("@/views/pedidos2/pedidos/cobranzas/components/RetencionListado.vue");

export default {
    mixins: [imprimirMixin],
    components: {
        "v-select": vSelect,
        flatPickr,
        screenFacturas,
        screenFacturasDevolucion,
        screenNotas,
        screenNotasDevolucion,
        screenCheques,
        facturasAbono,
        notasAbono,
        imprimirMixin,
        reporte,
        RetencionesComponent,
        ListadoRetencionesComponent,
        createdCuentasCruzadas,
        ListadoCrucesComponent
    },
    computed: {
        ...mapState(["auth", 'userRoot', 'susuario', 'ObjectPedido', 'groupFacturador', 'userAsesor', 'AdminFacturador']),
    },
    data() {
        return {
            menu: 3,
            arreglofacturas: [],
            arreglonotas: [],
            arreglocheques: [],
            arregloBeneficiario: [],
            arregloNotasFacturas: [],
            cantidadFacturas: 0,
            totalFacturas: 0,
            abonoFacturas: 0,
            cantidadNotas: 0,
            totalNotas: 0,
            abonoNotas: 0,
            totalAbonoFacturas: 0,
            totalAbonoNotas: 0,
            // pendienteNotas: 0,
            // pendienteFacturas: 0,
            popupAbonos: false,
            popupAbonosNotas: false,
            popupAbonosFacturas: false,
            popupCheques: false,
            mostrarCheques: false,
            permisosCheque: false,
            popupPDF: false,
            tabAbono: {
                notasOfactura: '',
                valor: '',
                tipoAbono: '',
                fecha: '',
                cuenta: '',
                numeroDocumento: '',
                concepto: '',
            },
            tabCheque: {
                banco: '',
                tipoCheque: '',
                valor: '',
                fechaCobro: '',
                referencia: '',
                numeroCheque: '',
                referencia: '',
                institucion: '',
                periodo: '',
                cuentaCheque: '',
            },
            tipoCheque: [{
                    text: '--Seleccione--',
                    value: null
                },
                {
                    text: 'Garantia',
                    value: 0
                },
                {
                    text: 'Posfechado',
                    value: 1
                },
            ],
            cliente: '',
            disableRadios: false,
            disableFacturas: false,
            arregloAbonoNotas: [],
            arregloAbonoFacturas: [],
            arrayPuntos: [],
            pedidoPuntosOInstitucion: '',
            institucionPuntosOInstitucion: '',
            periodoPuntosOInstitucion: 0,
            empresa: '',
            promptVisible: false,
            abono_id: '',
            setMenu: 0,
            ObjectSelected: '',
            tipoAbono: 0,
            configdateTimePicker: {
                enableTime: true,
                dateFormat: 'Y-m-d',
                onChange: this.onDateChange,
            },
            usuario: [],
            Cuentas: [],
            Bancos: [],
            Cheques: [],
            AllAbonos: [],
            arregloContrarios: [],
            // radiostipoAbono: 0,
            nombreDestintivo: '',
            nombreCliente: '',
            showCloseButton: false,
            devolucionesFacturas: [],
            devolucionesNotas: [],
            totalDevolucionesFacturas: 0,
            totalDevolucionesNotas: 0,
            popupVerNotas: false,
            popupVerNotasDevoluciones: false,
            popupVerFacturas: false,
            popupVerFacturasDevoluciones: false,
            devoluciones_all: [],
            cargoDevoluciones: false,
            datosDevolucionesSinEmpresa: [],
            totalDevolucionesSinEmpresa: 0,
            popupVerSinEmpresa: false,
            popupRetencion: false,
            porcentajeRetencion: [{
                    text: '--Seleccione--',
                    value: null
                },
                {
                    text: '0.75 %',
                    value: 0.75
                },
                {
                    text: '1 %',
                    value: 1
                },
                {
                    text: '1.75 %',
                    value: 1.75
                },
                {
                    text: '2 %',
                    value: 2
                },
                {
                    text: '2.75 %',
                    value: 2.75
                },
                {
                    text: '3 %',
                    value: 3
                },
                {
                    text: '10 %',
                    value: 10
                },
            ],
            tabRetencion: {
                fechaRetencion: '',
                porcentajeRetencion: '',
                documento: '',
                valor: '',
            },
            totalRetencionValor: 0,
            retencionValor: 0,
            totalCruceValor: 0,
            cruceValor: 0,
            totalCruceValorNotas: 0,
            cruceValorNotas: 0,
            popupRetencionNew: false,
            popupListadoRetencion: false,
            popupCuentasCruzadas: false,
            popupListadoCruces: false,
            tipoListadoCruces: '',
        };
    },
    props: {
        predioSeleccionado: {
            type: Number,
            default: 20
        },
        // InsticionCobranza: {
        //     type: [Object, Array],
        //     default: () => ({}),
        // },
        puntosCobranza: {
            type: [Object, Array],
            default: () => ({}),
        },
        periodoSelect: {
            type: Object,
            default: function () {
                return {}
            }
        },
        datosCliente: {
            type: Array,
            default: [],
        },
        empresaCobranza: {
            type: [Object, Array],
            default: () => ({}),
        },
    },
    created() {
        let me = this
        me.usuario = JSON.parse(localStorage.getItem("usuario"))
    },
    mounted() {
        let me = this;
        me.setMenu = localStorage.setMenu
        console.log("Datos cliente en el componente hijo:", this.datosCliente);
        me.nombreCliente = me.datosCliente[0].razonsocial;
        console.log("Nombre cliente:", me.nombreCliente);
        // console.log('institucion',me.InsticionCobranza);
        // console.log('punto',me.puntosCobranza);

        // me.institucionPuntosOInstitucion = me.InsticionCobranza.idInstitucion;
        me.periodoPuntosOInstitucion = me.predioSeleccionado;
        // me.nombreDestintivo = me.InsticionCobranza.nombreInstitucion
        me.empresa = me.empresaCobranza;
        me.getFacturaNotaParametro();
        me.GetCheque_todo();
        me.actualizarDatosAbono();
        // if (me.InsticionCobranza) {
        //     // me.pedidoPuntosOInstitucion = me.sendPedido.id_pedido;
        //     me.institucionPuntosOInstitucion = me.InsticionCobranza.idInstitucion;
        //     me.periodoPuntosOInstitucion = me.predioSeleccionado;
        //     me.nombreDestintivo = me.InsticionCobranza.nombreInstitucion

        //     me.getFacturaNotaParametro();
        //     me.GetCheque_todo();

        // } else  if (me.puntosCobranza) {
        //     // me.getFacturaNotaParametroPunto();
        //     // me.pedidoPuntosOInstitucion = me.sendPuntos.id_despacho;
        //     me.institucionPuntosOInstitucion = me.puntosCobranza.idInstitucion;
        //     me.periodoPuntosOInstitucion = me.predioSeleccionado;
        //     me.nombreDestintivo = me.puntosCobranza.nombreInstitucion

        //     me.getFacturaNotaParametro();

        // } else {
        //     console.log('error');
        // }

    },
    methods: {
        NuevoCruce() {
            let me = this;
            me.popupCuentasCruzadas = true;
        },
        editadoCruce(e){
            let me = this;
            this.actualizarDatosAbono();
            if(e == 'sin-datos'){
                this.popupListadoCruces = false;
                this.$vs.notify({
                    title: 'Sin Listado Cruces',
                    text: 'No se encontraron datos o no tiene cruces en la lista.',
                    color: 'warning',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle'
                })
            }
        },
        CerrarCrearcionCruce(e) {
            let me = this;
            console.log('entro al emit cruces cerrar ')
            if (e) {
                if (e == 'errorCodigo') {

                    this.$vs.notify({
                        title: 'Error',
                        text: 'Error al obtener el código del documento.',
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    });
                    me.popupCuentasCruzadas = false;

                } else if (e == 'guardado') {

                    this.actualizarDatosAbono();
                    me.popupCuentasCruzadas = false;

                } else if (e == 'cancelar-guardado') {

                    this.$vs.notify({
                        title: 'Mensaje',
                        text: 'Se canceló la creación del cruce.',
                        color: 'primary',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    });
                    me.popupCuentasCruzadas = false;

                } else if (e == 'error-guardado') {

                    me.popupCuentasCruzadas = false;

                }
            }

        },
        imprimirPDF() {
            // Emitir evento al hijo para ejecutar la impresión
            this.$refs.hijoComponente.m_imprimirTodos('12px', 'ReporteAbonos_' + this.datosCliente[0].razonsocial, '0px', '', 'landscape');
        },
        descargarExcel() {
            // Emitir evento al hijo para ejecutar la generación del archivo Excel
            this.$refs.hijoComponente.generateExcel();
        },
        MetodosInicio() {
            let me = this;
            me.getFacturaNotaParametro();
            me.GetCheque_todo();
            me.actualizarDatosAbono();
        },
        handleCloseCheque() {
            let me = this;
            me.popupCheques = true
        },
        handleCloseAbono() {
            let me = this;
            me.popupAbonos = true;
        },
        actualizarTodo() {
            let me = this;
            me.actualizarDatosAbono();
        },
        onDateChange(selectedDates, dateStr, instance) {
            instance.close();
        },
        agregarValorAlTextarea() {
            if (this.tabAbono.concepto) {
                this.tabAbono.concepto += ' ' + this.tabAbono.numeroDocumento;
            } else {
                this.tabAbono.concepto = this.tabAbono.numeroDocumento;
            }
        },
        seleccionTipo() {
            let me = this;
            if (!this.tabAbono.notasOfactura) {
                me.$vs.notify({
                    text: 'No a selecionado el destino de Cobro de cheque',
                    color: 'warning',
                    iconPack: 'feather',
                    icon: 'icon-alert-triangle'
                });
                me.camporequerido = true;
                return;
            } else {
                me.camporequerido = false;
            }
        },
        seleccionTipo2() {
            let me = this;
            if (!this.tabAbono.numeroDocumento) {
                me.$vs.notify({
                    text: 'No a ingresado el documento de Cobro de cheque',
                    color: 'warning',
                    iconPack: 'feather',
                    icon: 'icon-alert-triangle'
                });
                me.camporequerido = true;
                return;
            } else {
                me.camporequerido = false;
            }
        },
        NuevaRetencion() {
            let me = this;
            me.popupRetencionNew = true;
        },
        ListadoRetenciones() {
            let me = this;
            me.popupListadoRetencion = true;
        },
        ListadoCruces(tipo) {
            let me = this;
            me.tipoListadoCruces = tipo;
            me.popupListadoCruces = true;
        },
        changeHandleRetencionComponent(e) {
            let me = this;
            // console.log("realizarcchangeinicio")
            // console.log(e.verificacionemiteliminar); // Debería imprimir 1
            if (e.verificarretencion == 1) {
                console.log("Emit recibido por guardado.");
                me.popupRetencionNew = false;
                this.MetodosInicio();
            } else if (e.verificarretencion == 2) {
                console.log("Emit recibido por cerrar.");
                this.MetodosInicio();
                me.popupRetencionNew = false;
            } else {
                console.log("Emit no recibido");
            }
        },
        changeHandleListadoRetencionComponent(e) {
            let me = this;
            // console.log("realizarcchangeinicio")
            // console.log(e.verificacionemiteliminar); // Debería imprimir 1
            if (e.verificarlistadoretencion == 1) {
                console.log("Emit recibido por guardado.");
                me.popupListadoRetencion = false;
                this.MetodosInicio();
            } else if (e.verificarlistadoretencion == 2) {
                console.log("Emit recibido por cerrar.");
                this.MetodosInicio();
                me.popupListadoRetencion = false;
            } else {
                console.log("Emit no recibido");
            }
        },
        openConfirmEnviarPerseo(abono, tipo) {
            //tipo 0 = notas, 1 = facturas
            let me = this;
            me.$vs.dialog({
                title: 'Confirmación',
                text: `¿Estás seguro que deseas enviar el abono con ID ${abono.abono_id} a Perseo?`,
                acceptText: 'Enviar',
                cancelText: 'Cancelar',
                type: 'confirm',
                color: 'warning',
                accept: () => {
                    me.enviarPerseo(abono);
                },
                //cancelar
                cancel: () => {
                    if (tipo == 0) {
                        me.popupAbonosNotas = true;
                    }
                    if (tipo == 1) {
                        me.popupAbonosFacturas = true;
                    }
                }
            });
        },
        enviarPerseo() {
            let me = this;
            let formData = new FormData();
            formData.append("abono_id", this.ObjectSelected.abono_id);
            formData.append("usuarioCreador", `${this.usuario.nombres} ${this.usuario.apellidos}`);
            me.$vs.loading();
            this.$http
                .post(this.$server_url + "api/perseo/transaccion/cobros_crear", formData)
                .then((res) => {
                    if (res.data != null || res.data != undefined || res.data != 0) {
                        me.$vs.loading.close();
                        if (res.data.status == 0) {
                            me.$vs.notify({
                                text: res.data.message,
                                color: "danger",
                                iconPack: "feather",
                                icon: "icon-x",
                            });
                            return;
                        }
                        if (res.data.fault) {
                            me.$vs.notify({
                                text: "Ocurrio un error en el envío a Perseo",
                                color: "danger",
                                iconPack: "feather",
                                icon: "icon-x",
                            });
                            return;
                        }
                        if (me.tipoAbono == 0) {
                            me.obtenerAbonos('notas')
                        } else {
                            me.obtenerAbonos('facturas')
                        }
                        me.$vs.notify({
                            text: "Envío a Perseo exitoso",
                            color: "success",
                            iconPack: "feather",
                            icon: "icon-check",
                        });
                        //abrir modal
                        if (me.tipoAbono == 0) {
                            me.popupAbonosNotas = false;
                        }
                        if (me.tipoAbono == 1) {
                            me.popupAbonosFacturas = false;
                        }
                    } else {
                        me.$vs.loading.close();
                        me.$vs.notify({
                            text: "Se produjo algún fallo en el envío a Perseo",
                            color: "#F8C471",
                            iconPack: "feather",
                            icon: "icon-check",
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                    me.$vs.loading.close();
                    if (error.response.data.fault && error.response.data.fault.detail) {
                        me.$vs.notify({
                            text: error.response.data.fault.detail,
                            color: "danger",
                            iconPack: "feather",
                            icon: "icon-x",
                        });
                    } else {
                        me.$vs.notify({
                            text: "No se pudo enviar a Perseo",
                            color: "danger",
                            iconPack: "feather",
                            icon: "icon-x",
                        });
                    }
                });
        },
        chequeCobrado() {
            let me = this;
            me.getFacturaNotaParametro();
            me.GetCheque_todo();
            me.actualizarDatosAbono();
        },
        seleccionTipo() {
            let me = this;
            if (!this.tabAbono.notasOfactura) {
                me.$vs.notify({
                    text: 'No a selecionado el destino del Abono',
                    color: 'warning',
                    iconPack: 'feather',
                    icon: 'icon-alert-triangle'
                });
                return;
            }
        },
        resetearValor() {
            let me = this;
            me.tabAbono.valor = '';
        },
        validateInput(event) {
            const charCode = event.which ? event.which : event.keyCode;
            if ((charCode < 48 || charCode > 57) && charCode !== 44 && charCode !== 46) {
                event.preventDefault();
            }
        },
        validatePaste(event) {
            const clipboardData = event.clipboardData || window.clipboardData;
            const pastedText = clipboardData.getData('text/plain');
            const numbersOnly = pastedText.replace(/[^\d]/g, '');
            document.execCommand("insertText", false, numbersOnly);
            event.preventDefault();
        },
        validateQuantity() {
            let me = this;
            if (me.tabAbono.notasOfactura == 0) {
                let diferencia = this.totalFacturas - this.abonoFacturas;
                if (me.tabAbono.valor > diferencia) {
                    me.tabAbono.valor = diferencia.toFixed(2);
                }
            } else {
                let diferencia = this.totalNotas - this.abonoNotas;
                if (me.tabAbono.valor > diferencia) {
                    me.tabAbono.valor = diferencia.toFixed(2);
                }
            }

        },
        GetCuentasAll() {
            let me = this;
            this.$vs.loading();
            this.$http.get(this.$server_url + 'GetCuentasAll')
                .then(res => {
                    me.Cuentas = res.data.filter(cuentas => cuentas.cue_pag_estado != 1)
                    this.$vs.loading.close();
                })
                .catch(function (error) {
                    console.log(error + ' error');
                    me.$vs.loading.close();
                });
        },
        GetBanco_todo() {
            let me = this;
            this.$vs.loading();
            this.$http.post(this.$server_url + 'api/perseo/consultas/clientes_bancos_consulta')
                .then(res => {
                    me.Bancos = res.data['bancoc'];
                    // console.log(me.Bancos)
                    this.$vs.loading.close();
                })
                .catch(function (error) {
                    console.log(error + ' error');
                    me.$vs.loading.close();
                });
            // this.$http.get(this.$server_url + 'GetBanco_todo')
            //     .then(res => {                     
            //         me.Bancos = res.data
            //         this.$vs.loading.close();
            //     })
            //     .catch(function (error) {
            //         console.log(error + ' error');
            //         me.$vs.loading.close();
            //     });
        },
        GetCheque_todo() {
            let me = this;
            this.$vs.loading();
            // this.$http.get(this.$server_url + 'GetCheque_todo?institucion=' + me.institucionPuntosOInstitucion + '&periodo=' + me.periodoPuntosOInstitucion+'&empresa='+me.empresa.id+'&cliente='+me.datosCliente[0].clientesid)
            this.$http.get(this.$server_url + 'GetCheque_todo?periodo=' + me.periodoPuntosOInstitucion + '&empresa=' + me.empresa.id + '&cliente=' + me.datosCliente[0].identificacion)
                .then(res => {
                    me.Cheques = res.data;
                    if (me.Cheques) {
                        me.mostrarCheques = true;
                    }
                    this.$vs.loading.close();
                })
                .catch(function (error) {
                    console.log(error + ' error');
                    me.$vs.loading.close();
                });
        },
        menus(menu) {
            let me = this;
            me.menu = menu;
            if (menu != 3) {
                me.mostrarCheques = false;
            }
        },
        newAbono() {
            let me = this;
            me.tabAbono.valor = '';
            me.tabAbono.notasOfactura = '';
            me.tabAbono.fecha = new Date().toISOString().substr(0, 10);
            me.tabAbono.cuenta = '';
            me.tabAbono.numeroDocumento = '';
            me.tabAbono.concepto = 'CLIENTE: ' + me.nombreCliente + ' ' + 'DOCUMENTO: ';
            me.tabAbono.tipoAbono = '0';
            // me.radiostipoAbono = 0;
            me.GetCuentasAll();
            me.popupAbonos = true;

        },
        newCheque() {
            let me = this;
            me.GetBanco_todo();

            // me.tabCheque.institucion = me.InsticionCobranza.nombreInstitucion;
            me.tabCheque.banco = '';
            me.tabCheque.tipoCheque = '';
            me.tabCheque.valor = '';
            me.tabCheque.fechaCobro = new Date().toISOString().substr(0, 10);;
            me.tabCheque.referencia = me.periodoSelect.codigo_contrato;
            me.tabCheque.periodo = me.periodoPuntosOInstitucion;
            me.tabCheque.numeroCheque = '';
            me.tabCheque.cuentaCheque = '';
            me.popupCheques = true;

        },
        guardarAbono() {
            let me = this;
            let totalesFacturaNotas = (me.totalFacturas + me.totalNotas).toFixed(2);

            if (!me.tabAbono.fecha) {
                me.$vs.notify({
                    text: 'No a selecionado la fecha del abono',
                    color: 'warning',
                    iconPack: 'feather',
                    icon: 'icon-alert-triangle'
                });
                return;
            }
            if (!me.tabAbono.cuenta) {
                me.$vs.notify({
                    text: 'No a selecionado la cuenta del abono',
                    color: 'warning',
                    iconPack: 'feather',
                    icon: 'icon-alert-triangle'
                });
                return;
            }
            if (!me.tabAbono.tipoAbono) {
                me.$vs.notify({
                    text: 'No a seleccionado el tipo',
                    color: 'warning',
                    iconPack: 'feather',
                    icon: 'icon-alert-triangle'
                });
                return;
            }
            if (!me.tabAbono.numeroDocumento) {
                me.$vs.notify({
                    text: 'No a ingresado el deposito #',
                    color: 'warning',
                    iconPack: 'feather',
                    icon: 'icon-alert-triangle'
                });
                return;
            }
            if (!me.tabAbono.notasOfactura) {
                me.$vs.notify({
                    text: 'No a seleccionado el destino',
                    color: 'warning',
                    iconPack: 'feather',
                    icon: 'icon-alert-triangle'
                });
                return;
            }
            if (!me.tabAbono.valor) {
                me.$vs.notify({
                    text: 'No a ingresado el valor del abono',
                    color: 'warning',
                    iconPack: 'feather',
                    icon: 'icon-alert-triangle'
                });
                return;
            }
            if (me.tabAbono.valor == 0) {
                me.$vs.notify({
                    text: 'No puede enviar un abono 0',
                    color: 'warning',
                    iconPack: 'feather',
                    icon: 'icon-alert-triangle'
                });
                return;
            }
            if (!me.tabAbono.concepto.trim()) {
                me.$vs.notify({
                    text: 'No ha ingresado el concepto del abono.',
                    color: 'warning',
                    iconPack: 'feather',
                    icon: 'icon-alert-triangle'
                });
                return;
            }
            let abonoConcepto = me.tabAbono.concepto;

            abonoConcepto = abonoConcepto.replace(/ {5,}/g, '    ');
            let formData = new FormData();
            formData.append("notasOfactura", me.tabAbono.notasOfactura);
            formData.append("abono_fecha", me.tabAbono.fecha);
            formData.append("abono_tipo", me.tabAbono.tipoAbono);
            formData.append("abono_cuenta", me.tabAbono.cuenta);
            formData.append("abono_documento", me.tabAbono.numeroDocumento);
            formData.append("abono_valor", me.tabAbono.valor);
            formData.append("abono_empresa", me.empresa.id);
            // formData.append("institucion", me.institucionPuntosOInstitucion);
            formData.append("periodo", me.periodoPuntosOInstitucion);
            formData.append("abono_totalNotas", (me.totalNotas).toFixed(2));
            formData.append("abono_totalFacturas", (me.totalFacturas).toFixed(2));
            formData.append('abono_clientePerseo', me.usuario.idusuario);
            formData.append('idClientePerseo', me.datosCliente[0].clientesid);
            formData.append('clienteCodigoPerseo', me.datosCliente[0].clientescodigo);
            formData.append('user_created', me.usuario.idusuario);
            formData.append('abono_concepto', abonoConcepto);
            formData.append('abono_ruc_cliente', me.datosCliente[0].identificacion);
            // formData.append("tipo", me.setMenu );
            me.$vs.loading();
            this.$http.post(this.$server_url + 'abono_registro', formData)
                .then(function (res) {
                    me.$vs.loading.close()
                    if (res.data.status == 0) {
                        me.$vs.notify({
                            text: res.data.message,
                            color: 'warning',
                            iconPack: 'feather',
                            icon: 'icon-alert-triangle'
                        })
                        me.$vs.loading.close();
                    } else {
                        me.$vs.notify({
                            text: 'Se guardó correctamente',
                            color: 'primary',
                            iconPack: 'feather',
                            icon: 'icon-check'
                        })
                        me.popupAbonos = false
                        me.$vs.loading.close();
                    }
                    me.actualizarDatosAbono();
                })
                .catch(function (error) {
                    me.$vs.notify({
                        text: 'Error al guardar',
                        color: 'warning',
                        iconPack: 'feather',
                        icon: 'icon-alert-triangle'
                    })
                    me.$vs.loading.close();
                });
        },
        guardarCheque() {
            let me = this;
            if (!me.tabCheque.banco) {
                me.mostrarAlerta('No ha seleccionado el banco');
                return;
            }
            if (me.tabCheque.tipoCheque === null || me.tabCheque.tipoCheque === '') {
                me.mostrarAlerta('No ha seleccionado el tipo de cheque');
                return;
            }
            if (me.tabCheque.valor <= 0) {
                me.mostrarAlerta('El valor del cheque debe ser mayor que 0');
                return;
            }
            if (me.tabCheque.tipoCheque === 1 && (me.tabCheque.fecha === null || me.tabCheque.fecha === '')) {
                me.mostrarAlerta('No ha seleccionado la fecha del cheque');
                return;
            }
            if (!me.tabCheque.cuentaCheque) {
                me.mostrarAlerta('No ha ingresado la cuenta del cheque');
                return;
            }
            if (!me.tabCheque.numeroCheque) {
                me.mostrarAlerta('No ha ingresado el número del cheque');
                return;
            }
            if (!me.tabCheque.referencia) {
                me.mostrarAlerta('No ha ingresado la referencia del cheque');
                return;
            }

            // Construir objeto FormData con los datos del cheque
            let formData = new FormData();
            formData.append('ban_codigo', me.tabCheque.banco.bancocid);
            formData.append('chq_nombrebanco', me.tabCheque.banco.descripcion);
            formData.append('chq_tipo', me.tabCheque.tipoCheque);
            formData.append('chq_valor', me.tabCheque.valor);
            if (me.tabCheque.tipoCheque === 1) {
                formData.append('chq_fecha_cobro', me.tabCheque.fechaCobro);
            }
            formData.append('chq_cuenta', me.tabCheque.cuentaCheque);
            formData.append('chq_referenca', me.tabCheque.referencia);
            formData.append('chq_numero', me.tabCheque.numeroCheque);
            // formData.append('chq_institucion', me.institucionPuntosOInstitucion);
            formData.append('chq_periodo', me.periodoPuntosOInstitucion);
            formData.append('chq_empresa', me.empresa.id);
            formData.append('chq_cliente', me.datosCliente[0].identificacion);
            formData.append('user_created', me.usuario.idusuario);
            this.$http.post(this.$server_url + 'cheque_registro', formData)
                .then(response => {
                    this.$vs.loading.close();
                    if (response.data.status === 1) {
                        this.$vs.notify({
                            text: 'Cheque registrado correctamente',
                            color: 'success',
                            iconPack: 'feather',
                            icon: 'icon-check'
                        });
                        me.popupCheques = false;
                    } else if ((response.data.status === 0)) {
                        this.$vs.notify({
                            text: response.data.message,
                            color: 'warning',
                            iconPack: 'feather',
                            icon: 'icon-alert-triangle'
                        });
                    }
                    me.GetCheque_todo();
                    me.actualizarDatosAbono();

                })
                .catch(error => {
                    this.$vs.notify({
                        text: 'Error al registrar el cheque: ' + error.response.data.message,
                        color: 'error',
                        iconPack: 'feather',
                        icon: 'icon-alert-triangle'
                    });
                });
        },
        actualizarDatosAbono() {
            let me = this;
            // me.$http.get(me.$server_url + 'abono_pedido?institucion=' + me.institucionPuntosOInstitucion + '&periodo=' + me.periodoPuntosOInstitucion+'&empresa='+me.empresa.id+'&cliente='+me.datosCliente[0].clientesid)
            me.$http.get(me.$server_url + 'abono_pedido?periodo=' + me.periodoPuntosOInstitucion + '&empresa=' + me.empresa.id + '&cliente=' + me.datosCliente[0].identificacion)
                .then(function (resAbono) {
                    let abonoDatos = resAbono.data;

                    if (abonoDatos.length > 0) {
                        me.abonoFacturas = parseFloat(abonoDatos[0].abonofacturas);
                        me.abonoNotas = parseFloat(abonoDatos[0].abononotas);
                        me.totalAbonoFacturas = parseFloat(abonoDatos[0].totalAbonoFacturas);
                        me.totalAbonoNotas = parseFloat(abonoDatos[0].totalAbonoNotas);
                        me.totalRetencionValor = parseFloat(abonoDatos[0].totalRetencionValor);
                        me.retencionValor = parseFloat(abonoDatos[0].retencionValor);
                        me.totalCruceValor = parseFloat(abonoDatos[0].totalCruceValor);
                        me.cruceValor = parseFloat(abonoDatos[0].cruceValor);
                        me.totalCruceValorNotas = parseFloat(abonoDatos[0].totalCruceValorNotas);
                        me.cruceValorNotas = parseFloat(abonoDatos[0].cruceValorNotas);
                        // me.pendienteFacturas -= me.totalAbonoFacturas;
                        // me.pendienteNotas -= me.totalAbonoNotas;
                    } else {
                        me.abonoFacturas = 0;
                        me.abonoNotas = 0;
                        me.totalAbonoFacturas = 0;
                        me.totalAbonoNotas = 0;
                        me.pendienteFacturas = 0;
                        me.pendienteNotas = 0;
                        me.totalRetencionValor = 0;
                        me.retencionValor = 0;
                        me.totalCruceValor = 0;
                        me.cruceValor = 0;
                        me.totalCruceValorNotas = 0;
                        me.cruceValorNotas = 0;
                    }
                })
                .catch(function (errorAbono) {
                    console.log(errorAbono + ' error');
                });
        },
        mostrarAlerta(mensaje) {
            this.$vs.notify({
                text: mensaje,
                color: 'warning',
                iconPack: 'feather',
                icon: 'icon-alert-triangle'
            });
        },
        getFacturaNotaParametro() {
            let me = this;
            let busqueda, ruc, ci;

            let identificacion = me.datosCliente[0].identificacion;
            let esRUC = identificacion.length >= 11 && identificacion.length <= 13 ? true : false;

            if (esRUC) {
                ruc = identificacion;
                busqueda = identificacion.slice(0, -3); // Eliminar los últimos 3 dígitos para RUC
                ci = busqueda;
            } else {
                ci = identificacion; // Añadir '001' al final para CI
                ruc = identificacion + '001';
                busqueda = identificacion;
            }

            this.$vs.loading();
            this.$http.get(`${this.$server_url}get_facturasNotasxParametro?periodo=${me.periodoPuntosOInstitucion}&empresa=${me.empresa.id}&cliente=${busqueda}`)
                .then(function (res) {
                    let datos = res.data;
                    me.arregloNotasFacturas = datos;
                    let arregloNotasFacturasValidacion = datos;
                    console.log(esRUC, busqueda);

                    if (arregloNotasFacturasValidacion.length > 0) {
                        if (esRUC) {
                            // Si es RUC, buscar en los datos usando CI
                            me.arregloContrarios = arregloNotasFacturasValidacion.filter(item => item.ruc_cliente == ci);
                            console.log('Documentos Contrarios ala busqueda RUC', me.arregloContrarios);
                            console.log(' busqueda', busqueda);
                            me.$vs.notify({
                                text: "Cliente con documentos con RUC y CI",
                                color: "warning",
                                iconPack: "feather",
                                icon: "icon-check",
                            });
                        } else {
                            // Si es CI, buscar en los datos usando RUC
                            me.arregloContrarios = arregloNotasFacturasValidacion.filter(item => item.ruc_cliente == ruc);
                            console.log('Documentos Contrarios ala busqueda CI', me.arregloContrarios);
                            me.$vs.notify({
                                text: "Cliente con documentos con CI y RUC",
                                color: "warning",
                                iconPack: "feather",
                                icon: "icon-check",
                            });
                        }
                    }

                    if (me.arregloNotasFacturas.length > 0) {
                        me.menu = 3;
                        me.arreglofacturas = datos.filter(item => item.idtipodoc === 1);
                        me.cantidadFacturas = me.arreglofacturas.length;
                        me.totalFacturas = me.arreglofacturas.reduce((total, factura) => total + factura.ven_valor, 0);
                        // me.pendienteFacturas = me.totalFacturas;

                        me.arreglonotas = datos.filter(item => item.idtipodoc === 4 || item.idtipodoc === 3);
                        me.cantidadNotas = me.arreglonotas.length;
                        me.totalNotas = me.arreglonotas.reduce((total, nota) => total + nota.ven_valor, 0);
                        // me.pendienteNotas = me.totalNotas;

                        me.permisosCheque = true;

                        me.actualizarDatosAbono();
                        me.getClienteDocumentosdevolucioneSinEmpresa();
                        setTimeout(function () {
                            me.$vs.loading();
                            me.traerDevoluciones(me.arreglonotas, me.arreglofacturas);
                        }, 500);

                    } else {
                        me.$vs.loading.close();
                        me.$vs.notify({
                            text: "Cliente sin documentos",
                            color: "warning",
                            iconPack: "feather",
                            icon: "icon-check",
                        });
                    }

                })
                .catch(function (error) {
                    console.log(error + ' error');
                    me.$vs.loading.close();
                });
        },
        getClienteDocumentosdevolucioneSinEmpresa() {
            let me = this;
            this.$http.get(`${this.$server_url}getClienteDocumentos?cliente=${me.datosCliente[0].identificacion}`)
                .then(function (res) {
                    let datos = res.data;
                    me.datosDevolucionesSinEmpresa = datos[0];

                    // Calcular el total de las devoluciones
                    me.totalDevolucionesSinEmpresa = me.datosDevolucionesSinEmpresa.reduce((total, devolucion) => total + devolucion.total_precio, 0);

                    console.log('Datos de devoluciones sin empresa:', me.datosDevolucionesSinEmpresa);
                    console.log('Total de devoluciones sin empresa:', me.totalDevolucionesSinEmpresa);

                    // Si se desea mostrar un popup o modal después de obtener los datos
                    // me.popupVerSinEmpresa = true;
                })
                .catch(function (error) {
                    console.log('Error:', error);
                    me.$vs.loading.close();
                });
        },
        async traerDevoluciones(notas, facturas) {
            let me = this;
            me.devolucionesFacturas = [];
            me.devolucionesNotas = [];

            // Función para obtener detalles de devolución
            const obtenerDetallesDevolucion = async (documento) => {
                try {
                    const res = await me.$http.get(`${me.$server_url}obtenerDetallesDevolucion?documento=${documento}&empresa=${me.empresa.id}`);
                    return res.data.length > 0 ? res.data : []; // Devuelve el array de devoluciones
                } catch (error) {
                    console.error('Error obteniendo detalles de devolución:', error);
                    return []; // Devuelve un array vacío si hay un error
                }
            };

            // Iniciar loading
            me.$vs.loading();

            // Función genérica para procesar facturas o notas
            const procesarDevoluciones = async (documentos, tipo) => {
                const devoluciones = await Promise.all(documentos.map(async (documento) => {
                    const detalles = await obtenerDetallesDevolucion(documento.ven_codigo);
                    return detalles.map(devolucion => ({
                        codigo_devolucion: devolucion.codigo_devolucion,
                        id_cliente: devolucion.id_cliente,
                        total_precio: devolucion.total_precio,
                        nombreInstitucion: devolucion.nombreInstitucion,
                        total_descuento: devolucion.ValorConDescuento,
                        documento: devolucion.documento
                    }));
                }));

                // Aplanar el array de devoluciones y asignarlo a la propiedad correspondiente
                const devolucionesAplanadas = devoluciones.flat();
                if (tipo === 'facturas') {
                    me.devolucionesFacturas = devolucionesAplanadas;
                } else if (tipo === 'notas') {
                    me.devolucionesNotas = devolucionesAplanadas;
                }
            };

            try {
                // Ejecutar ambas funciones en paralelo
                await Promise.all([
                    procesarDevoluciones(facturas, 'facturas'),
                    procesarDevoluciones(notas, 'notas')
                ]);

                // Calcular los totales por separado para facturas y notas
                me.totalDevolucionesFacturas = me.devolucionesFacturas.reduce((total, devolucion) => total + devolucion.total_descuento, 0);
                me.totalDevolucionesNotas = me.devolucionesNotas.reduce((total, devolucion) => total + devolucion.total_descuento, 0);

                // Combinar todas las devoluciones
                me.devoluciones_all = [...me.devolucionesFacturas, ...me.devolucionesNotas];

                // Verificar si el número de devoluciones coincide
                if ((me.devolucionesFacturas.length + me.devolucionesNotas.length) === me.devoluciones_all.length) {
                    me.cargoDevoluciones = true;
                } else {
                    console.error('No hay coincidencias en los datos de devoluciones');
                }
            } catch (error) {
                console.error('Error procesando las devoluciones:', error);
            } finally {
                // Cerrar el loading al finalizar
                me.$vs.loading.close();
            }
        },

        openabonoNotas() {
            let me = this;
            me.popupAbonosNotas = true;
            // me.obtenerAbonos('notas')

        },
        openabonoFacturas() {
            let me = this;
            me.popupAbonosFacturas = true;
            // me.obtenerAbonos('facturas')

        },
        obtenerAbonos(documento) {
            let me = this;
            this.$vs.loading();
            // this.$http.get(this.$server_url + 'obtenerAbonos?institucion=' + me.institucionPuntosOInstitucion + '&periodo=' + me.periodoPuntosOInstitucion+'&empresa='+me.empresa.id)
            this.$http.get(this.$server_url + 'obtenerAbonos?periodo=' + me.periodoPuntosOInstitucion + '&empresa=' + me.empresa.id + '&cliente=' + me.datosCliente[0].identificacion)
                .then(res => {
                    let datos = res.data;

                    if (documento === 'notas') {
                        me.arregloAbonoNotas = datos.abonos_con_notas.map(abono => ({
                            ...abono,
                            created_at: new Date(abono.created_at).toLocaleString(),
                            updated_at: new Date(abono.updated_at).toLocaleString()
                        }));
                    } else if (documento === 'facturas') {
                        me.arregloAbonoFacturas = datos.abonos_con_facturas.map(abono => ({
                            ...abono,
                            created_at: new Date(abono.created_at).toLocaleString(),
                            updated_at: new Date(abono.updated_at).toLocaleString()
                        }));
                    } else if (documento === 'excel') {
                        me.AllAbonos = datos;
                        me.exportToExcel();
                    } else if (documento === 'pdf') {
                        me.AllAbonos = datos;
                        me.popupPDF = true;

                    }

                    this.$vs.loading.close();
                })
                .catch(function (error) {
                    console.log(error + ' error');
                    me.$vs.loading.close();
                });
        },
        remover(abono) {
            let me = this;
            me.abono_id = abono;
            me.popupAbonosNotas = false;
            me.popupAbonosFacturas = false
            me.promptVisible = true;
        },
        cancelarEliminarAbono() {
            this.popupAbonosNotas = true;
            this.popupAbonosFacturas = true;
            this.promptVisible = false;
        },
        eliminarAbono(abono) {
            let me = this;
            this.$http.post(this.$server_url + 'eliminarAbono?', {
                    abono_id: abono.abono_id,
                    usuario: me.usuario.idusuario
                })
                .then(res => {
                    if (res.data.message) {
                        me.$vs.notify({
                            text: res.data.message,
                            color: "success",
                            iconPack: "feather",
                            icon: "icon-check-circle",
                        });
                    } else {
                        me.$vs.notify({
                            text: 'Abono eliminado correctamente',
                            color: "success",
                            iconPack: "feather",
                            icon: "icon-check-circle",
                        });
                    }
                    me.promptVisible = false;
                    me.popupAbonosNotas = false;
                    me.popupAbonosFacturas = false;
                    this.actualizarDatosAbono();
                })
                .catch(error => {
                    console.error('Error al eliminar abono:', error);
                    me.$vs.notify({
                        text: 'Error al eliminar el abono',
                        color: "danger",
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                    });
                });
        },
        exportToExcel() {
            let me = this;
            const formatDate = (fecha) => {
                if (!fecha) return '';
                const date = new Date(fecha);
                return date.toISOString().split('T')[0];
            };

            const reportTitle = 'REPORTE - CARTERA POR COBRAR - ' + me.datosCliente[0].razonsocial;
            const empresa = me.empresa.descripcion_corta;
            const fechaActual = new Date().toLocaleDateString('es-ES', {
                day: 'numeric',
                month: 'long',
                year: 'numeric'
            });

            const wsData = [];
            wsData.push([reportTitle, '', '', '', '', '', '', '', '', empresa]); // Título
            wsData.push(['Fecha: ' + fechaActual]); // Fecha
            wsData.push([]); // Espacio vacío

            // Encabezados
            const headers = ["Código", "Tipo", "Fecha", "Valor", "Abono", "Destino", "Fecha Abono", "Dep. N°", "Dev. Valor", "Dev. Documento", "Dev. Referencia"];
            wsData.push(headers);

            // Combinar datos de facturas, abonos y devoluciones
            const combinedData = [];
            let totalventa = 0;
            let totalabono = 0;
            let totaldescuento = 0;

            // Iterar sobre las facturas
            for (let i = 0; i < this.arregloNotasFacturas.length; i++) {
                const factura = this.arregloNotasFacturas[i];
                const abono = this.AllAbonos['abonos_all'][i] || {};

                const abonoValor = parseFloat(abono.abono_notas > 0 ? abono.abono_notas :
                    abono.abono_facturas > 0 ? abono.abono_facturas : 0) || 0;

                // Buscar todas las devoluciones correspondientes a la factura (si existen)
                const devoluciones = this.devoluciones_all.filter(d => d.documento === factura.ven_codigo);

                let devolucionCodigo = '';
                let devolucionDocumento = '';
                let devolucionDescuento = 0;

                // Si hay devoluciones, las agrupamos por documento
                if (devoluciones.length > 0) {
                    // Agrupar devoluciones por documento
                    const devolucionesAgrupadas = devoluciones.reduce((acumulador, devolucion) => {
                        if (!acumulador[devolucion.documento]) {
                            acumulador[devolucion.documento] = {
                                codigosDevolucion: [],
                                totalDescuento: 0
                            };
                        }
                        acumulador[devolucion.documento].codigosDevolucion.push(devolucion.codigo_devolucion);
                        acumulador[devolucion.documento].totalDescuento += parseFloat(devolucion.total_descuento || 0);
                        return acumulador;
                    }, {});

                    // Ahora, para cada grupo de devoluciones con el mismo documento, agregamos la fila
                    Object.keys(devolucionesAgrupadas).forEach(documento => {
                        const agrupado = devolucionesAgrupadas[documento];
                        devolucionCodigo = agrupado.codigosDevolucion.join(', '); // Concatenamos los códigos
                        devolucionDocumento = documento; // El documento de referencia
                        devolucionDescuento = agrupado.totalDescuento; // Sumar los descuentos
                    });
                }

                // Agregar la fila con los datos de la factura y las devoluciones agrupadas
                combinedData.push([
                    factura.ven_codigo || '',
                    factura.idtipodoc === 1 ? 'PreFactura' :
                    factura.idtipodoc === 2 ? 'Acta' :
                    factura.idtipodoc === 4 ? 'Nota' :
                    factura.idtipodoc === 3 ? 'Nota' : 'error',
                    formatDate(factura.ven_fecha),
                    (Number(factura.ven_valor) || 0).toFixed(2) * 1,
                    abonoValor.toFixed(2) * 1,
                    abono.abono_notas > 0 ? 'Notas' :
                    abono.abono_facturas > 0 ? 'PreFactura' : '',
                    abono.abono_fecha || '',
                    abono.abono_documento || '',
                    devolucionDescuento.toFixed(2) * 1, // Total descuento de las devoluciones agrupadas
                    devolucionCodigo, // Códigos de devolución concatenados
                    devolucionDocumento, // Documento de la devolución (referencia)
                ]);

                totalventa += Number(factura.ven_valor) || 0;
                totalabono += abonoValor;
                totaldescuento += devolucionDescuento;
            }

            // Agregar los abonos que no tienen factura asociada
            for (let j = 0; j < this.AllAbonos['abonos_all'].length; j++) {
                if (j >= this.arregloNotasFacturas.length) {
                    const abono = this.AllAbonos['abonos_all'][j];
                    const abonoValor = parseFloat(abono.abono_notas > 0 ? abono.abono_notas :
                        abono.abono_facturas > 0 ? abono.abono_facturas : 0) || 0;

                    combinedData.push([
                        '',
                        '',
                        '',
                        '',
                        abonoValor.toFixed(2),
                        abono.abono_notas ? 'Notas' : 'PreFactura',
                        abono.abono_fecha || '',
                        abono.abono_documento || '',
                        '', // No hay devolución asociada
                        '', // Documento de devolución
                        '0.00' // Total descuento
                    ]);
                    totalabono += abonoValor;
                }
            }

            // Agregar los datos al array de salida
            combinedData.forEach(row => {
                wsData.push(row);
            });

            // Calcular y agregar los totales
            const saldo = totalventa - totaldescuento - totalabono;
            wsData.push(['', '', 'Total Venta', totalventa.toFixed(2) * 1, totalabono.toFixed(2) * 1, '', '', '', totaldescuento.toFixed(2) * 1]);
            wsData.push(['', '', 'Pagos', totalabono.toFixed(2) * 1 + totaldescuento.toFixed(2) * 1]);
            wsData.push(['', '', 'Saldo', saldo.toFixed(2) * 1]);

            // wsData.push(['']);
            // wsData.push(['']);
            // wsData.push(['']);

            // const headers2 = ["Dev. Valor", "Dev. Documento", "Dev. Referencia"];
            // wsData.push(headers2);
            // // Agregar los datos al array de Devolucion sin documentos
            // me.datosDevolucionesSinEmpresa.forEach(row => {
            //     wsData.push(row);
            // });

            // Crear el libro de trabajo y la hoja
            const wb = XLSX.utils.book_new();
            const ws = XLSX.utils.aoa_to_sheet(wsData);

            // Combinar celdas para el título
            ws['!merges'] = [{
                    s: {
                        r: 0,
                        c: 0
                    },
                    e: {
                        r: 0,
                        c: 7
                    }
                },
                {
                    s: {
                        r: 1,
                        c: 0
                    },
                    e: {
                        r: 1,
                        c: 9
                    }
                }
            ];

            // Agregar la hoja al libro
            XLSX.utils.book_append_sheet(wb, ws, 'Reporte');

            // Exportar el archivo Excel
            XLSX.writeFile(wb, 'ReporteVentas_' + (me.datosCliente[0].razonsocial).trim() + '.xlsx');
        },
        guardarRetencion() {
            let me = this;
            if (!me.tabRetencion.porcentajeRetencion) {
                me.$vs.notify({
                    text: 'No a ingresado la retencion',
                    color: 'warning',
                    iconPack: 'feather',
                    icon: 'icon-alert-triangle'
                });
                return;
            }
            let formData = new FormData();
            formData.append("abono_fecha", me.tabRetencion.fechaRetencion);
            formData.append("abono_porcentaje", me.tabRetencion.porcentajeRetencion);
            // formData.append("abono_documento",  me.tabRetencion.documento);
            formData.append("abono_valor_retencion", me.tabRetencion.valor);
            formData.append("abono_tipo", 3);
            // formData.append('abono_institucion', me.instituion);
            formData.append('abono_periodo', me.periodoPuntosOInstitucion);
            formData.append('user_created', me.usuario.idusuario);
            formData.append('abono_empresa', me.empresa.id);
            formData.append('abono_clientePerseo', me.datosCliente[0].identificacion);

            formData.append('idClientePerseo', me.datosCliente[0].clientesid);
            formData.append('clienteCodigoPerseo', me.datosCliente[0].clientescodigo);
            formData.append('abono_ruc_cliente', me.datosCliente[0].identificacion);

            me.$vs.loading();
            this.$http.post(this.$server_url + 'retencion_registro', formData)
                .then(function (res) {
                    me.$vs.loading.close()
                    if (res.data.status == 0) {
                        me.$vs.notify({
                            text: res.data.message,
                            color: 'warning',
                            iconPack: 'feather',
                            icon: 'icon-alert-triangle'
                        })
                        me.$vs.loading.close();
                    } else {
                        me.$vs.notify({
                            text: 'Se guardó correctamente',
                            color: 'primary',
                            iconPack: 'feather',
                            icon: 'icon-alert-triangle'
                        })
                        me.popupRetencion = false
                        me.$vs.loading.close();
                        this.actualizarDatosAbono();
                    }
                })
                .catch(function (error) {
                    me.$vs.notify({
                        text: error.response.data.message, // Aquí usamos error en lugar de res
                        color: 'warning',
                        iconPack: 'feather',
                        icon: 'icon-alert-triangle'
                    })
                    me.$vs.loading.close();
                });
        },
    }
}
</script>

<style>
.box p {
    color: hsl(229, 6%, 66%);
}

.box {
    border-radius: 5px;
    box-shadow: 0px 30px 40px -20px hsl(229, 6%, 66%);
    padding: 30px;
    margin: 20px;
    background-color: white;
    cursor: pointer;
    transition: 1s ease;
}

.box:hover {
    box-shadow: 15px 10px 15px #0000;
}

@media (max-width: 912px) {
    .box {
        width: 100% !important;
    }

    img {
        margin-top: -40px;
        width: 50px;
    }
}

@media (max-width: 820px) {
    .box {
        width: 100% !important;
    }

    img {
        margin-top: -40px;
        width: 50px;
    }
}

@media (max-width: 450px) {
    .box {
        height: 200px;
    }

    .img {
        margin-top: -40px;
    }
}

@media (max-width: 400px) {
    img {
        margin-top: -40px;
        width: 50px;
    }
}

@media (max-width: 414px) {
    .box {
        width: 100% !important;
    }

    img {
        margin-top: -40px;
        width: 50px;
    }
}

@media (max-width: 375px) {
    .box {
        width: 100% !important;
    }

    img {
        margin-top: -40px;
        width: 50px;
    }
}

@media (max-width: 280px) {
    .box {
        width: 100% !important;
    }

    img {
        margin-top: -40px;
        width: 50px;
    }
}

@media (max-width: 950px) and (min-width: 450px) {
    .box {
        text-align: center;
        height: 180px;
    }
}

.purple {
    border-top: 3px solid hsl(261, 81%, 61%);
    box-shadow: 2px 2px 10px hsla(261, 44%, 75%, 0.849);
    border-radius: 10px;
    padding: 10px;
}

.orange {
    border-top: 3px solid hsl(34, 97%, 64%);
    box-shadow: 2px 2px 10px hsla(24, 57%, 65%, 0.842);
    border-radius: 10px;
    padding: 10px;
}

@media (min-width: 950px) {
    .row1-container {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .row2-container {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .box-down {
        position: relative;
        top: 150px;
    }

    .box {
        width: 28%;

    }

    .header p {
        width: 30%;
    }

}

.facturas {
    background: #c018b8;
    color: #fff;
    min-width: 20px;
    height: 25px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    width: 25px;
}

.text-purple {
    color: hsl(261, 81%, 61%);
    ;
}

.text-orange {
    color: hsl(34, 97%, 64%);
}

.text-red {
    color: hsl(7, 97%, 64%);
}

.text-blue {
    color: hsl(241, 97%, 64%);
}

/* .box.purple {
                position: relative;
                padding: 20px;  Ajusta según sea necesario
                background-image: url('https://cdn-icons-png.flaticon.com/512/3062/3062544.png');
                background-size:auto;
                background-position: center;
                background-repeat: no-repeat;
                background-blend-mode: lighten; Ajusta el blend mode según sea necesario

                background-color: rgba(255, 255, 255, 0.5); Fondo semitransparente
                color: #333; Color del texto para asegurar contraste
            }

            .box.purple .content {
                position: relative;
                z-index: 1;
            } */
</style><style scoped>
.popopPadre {
    z-index: 51002;
    /* Valor mayor que el del popup del padre */
    position: fixed;
    /* Asegúrate de que la posición sea adecuada */
}
</style><style lang="scss">
.hide-close .vs-popup--close {
    display: none;
}

/* Ajustes generales solo para las tablas dentro de las tarjetas específicas */

/* Ajustar títulos h2 (custom-heading) */
.custom-heading {
    font-size: 1.4rem;
    font-weight: 900;
    line-height: 1.3;
}

/* Ajustar subtítulos h4 dentro de las tablas */
.custom-subheading {
    font-size: 1.4rem;
    /* Reducir el tamaño del h4 */
    font-weight: 800;
    /* Hacerlo más ligero */
    line-height: 1.3;
}

/* Aplicar ajustes solo a las tablas de PreFacturas */
.custom-table-prefacturas {
    width: 100%;
    table-layout: fixed;
    /* Hacer la tabla más compacta */
    word-wrap: break-word;
    /* Evitar desbordes de texto */
}

.custom-table-prefacturas td {
    padding-top: 6px;
    padding-bottom: 6px;
    font-size: 0.9rem;
}

.custom-table-prefacturas tr {
    border: 1px solid black;

}

/* Aplicar ajustes solo a las tablas de Notas */
.custom-table-notas {
    width: 100%;
    table-layout: fixed;
    word-wrap: break-word;
}

.custom-table-notas td {
    padding-top: 6px;
    padding-bottom: 6px;
    font-size: 0.9rem;
}

.custom-table-notas td h4 {
    font-size: 0.9rem;
    margin: 0;
}

/* Alineación de celdas */
.text-right {
    text-align: right;
}

/* Botones dentro de las tarjetas */
.vs-button {
    font-size: 0.9rem;
    padding: 6px 12px;
}

.informacionformhijo {
    z-index: 51001;
    /* Asegúrate de que este valor sea alto para que el popup hijo del hijo pueda superponerse */
    /* position: fixed; */
    /* Asegúrate de que la posición sea adecuada */
}
</style>
